import React, { useEffect } from 'react'
import AboutBanner from './Banner/AboutBanner'
import AboutFoundation from './Foundation/AboutFoundation'
import AboutVision from './Vision/AboutVision'
import AboutProtocol from './Protocol/AboutProtocol'
import AboutTaken from './AboutToken/AboutTaken'
import AboutTrade from './Trade/AboutTrade'
import Chain from './AboutChain/Chain'
import Fee from './Fee/Fee'
import { useTheme } from '../../contexts/ThemeProvider'
import Navbar from '../Homepage/Navbar/Navbar'
import Footer from '../Homepage/footer/Footer'
import SEO from '../SEO'
import Nasdaq from './Nasdaq/Nasdaq'
import Storm from '../Homepage/Storm/Storm'
// import Nasdaq from './Nasdaq/Nasdaq'

const About = () => {
  const { theme, toggle } = useTheme();

  useEffect(() => {
    if (theme !== "dark") {
      toggle();
    }
  }, []);
  return (
    <>
      <SEO
        url='https://www.rain.one/about-us'
      />
      <Navbar />
      <AboutBanner />
      <AboutFoundation />
      <AboutVision />
      <AboutProtocol />
      <AboutTaken />
      <Nasdaq/>
      <AboutTrade />
      <Chain />
      <Fee />
      <Storm />
      <Footer />
    </>
  )
}

export default About